import $ from 'jquery';
import Swiper, { lazy } from 'swiper/core';
import LazyLoad from 'vanilla-lazyload';

class Cart {
	constructor() {
		this.cart = $('#cart');
		this.input = $('.cart__quantity');
		this.cartClose = $('#cart-close');
		this.body = $('body');
		this.overlay = $('.overlay');
		this.events();
		this.initCarousel();
	}

	events() {
		let _this = this;
		$(document).click((e) => {
			var el = $(e.target),
				attr =
					$(e.target).attr('href') !== undefined
						? $(e.target).attr('href')
						: $(e.target).parent().attr('href');

			if (attr === '#cart') {
				e.preventDefault();

				if (!this.isCartActive()) {
					this.openCart();
				} else {
					this.closeCart();
				}
			}

			if ($(el).hasClass('quantity-up')) {
				_this.upQuantity(el);
			}

			if ($(el).hasClass('quantity-down')) {
				_this.downQuantity(el);
			}
		});
		$('input.quantity').on('keyup keydown', (e) => {
			if (e.key === 'Escape' && this.isCartActive()) {
				this.closeCart();
			}

			var inputValue = $(e.target).val(),
				roundInput = this.validInputValue(inputValue);
			this.replaceInputValue($(e.target), roundInput);
		});

		//close cart when click on close button
		this.cartClose
			.click((e) => {
				e.preventDefault();
				this.closeCart();
			})
			.bind(this);

		$(document).ajaxComplete((event, xhr, settings) => {
			console.log(event, xhr, settings);
			console.log(event.status);
			if (settings.url == '/cart?view=sticky') {
				if (xhr.status == 200 && xhr.readyState == 4) {
					setTimeout(() => {
						this.initCartCarousel();
					});
				}
			}

			var lazyImg = new LazyLoad({
				elements_selector: '.carts .lazy',
			});

			lazyImg.loadAll();
			lazyImg.update();
		});
	}

	//open cart
	openCart() {
		this.cart.addClass('open');
		this.overlay.fadeIn();
	}

	//close cart
	closeCart() {
		this.cart.removeClass('open');
		this.overlay.fadeOut();
	}

	//increase quantity
	upQuantity(el) {
		let input = $(el).parent().find('input[type="number"]'),
			currentQuantity = parseFloat(input.val()),
			increaseQuantity = (currentQuantity += 1);
		input.val(increaseQuantity);
	}

	//increase quantity
	downQuantity(el) {
		let input = $(el).parent().find('input[type="number"]'),
			currentQuantity = parseFloat(input.val()),
			decreaseQuantity = (currentQuantity -= 1);
		if (decreaseQuantity > 1) {
			input.val(decreaseQuantity);
		} else {
			input.val(1);
		}
	}

	validInputValue(number) {
		var number = parseInt(number);
		number = isNaN(number) ? 1 : Math.floor(number);
		console.log(number);
		return number;
	}

	replaceInputValue(input, value) {
		$(input).val(value);
	}

	isCartActive() {
		return this.cart.hasClass('open');
	}

	//init mobile
	initCarousel() {
		this.initCartCarousel();
		$(window).on('resize', () => {
			setTimeout(() => {
				this.initCartCarousel();
			}, 400);
		});
	}

	initCartCarousel() {
		if ($(window).width() < 768) {
			var cartCarousel, cartBestseller;

			cartCarousel = new Swiper('#cart-carousel', {
				spaceBetween: 0,
				slidesPerView: 2.5,
				observer: true,
				observeParents: true,
				observeSlideChildren: true,
				speed: 600,
				lazy: {
					loadPrevNext: true,
					elementClass: 'lazy',
				},
				breakpoints: {
					320: {
						slidesPerView: 2.8,
					},
					375: {
						slidesPerView: 2.2,
					},
				},
			});

			cartBestseller = new Swiper('#cart-carousel-bestseller', {
				spaceBetween: 0,
				slidesPerView: 2.5,
				observer: true,
				observeParents: true,
				observeSlideChildren: true,
				speed: 600,
				lazy: {
					loadPrevNext: true,
					elementClass: 'lazy',
				},
				breakpoints: {
					320: {
						slidesPerView: 2.8,
					},
					375: {
						slidesPerView: 1.5,
					},
				},
			});
		} else {
			if (cartBestseller !== undefined || cartCarousel !== undefined) {
				$('.cart-sidebar .swiper-wrapper').removeAttr('style');
				$('.cart-sidebar .swiper-slide').removeAttr('style');
			}
		}
	}
}

export default Cart;
